module.exports = __webpack_public_path__ + "img/progress_014.ebe48480.png";